var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccFlightTabEnabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9206_429029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9.7187C14 9.4787 13.8733 9.2587 13.6733 9.12536L8.66665 5.9987V2.33203C8.66665 1.7787 8.21998 1.33203 7.66665 1.33203C7.11331 1.33203 6.66665 1.7787 6.66665 2.33203V5.9987L1.65998 9.12536C1.45998 9.25203 1.33331 9.4787 1.33331 9.7187C1.33331 10.1854 1.78665 10.5254 2.23998 10.3854L6.66665 8.9987V12.6654L5.46665 13.5654C5.37998 13.6254 5.33331 13.7254 5.33331 13.832V14.2254C5.33331 14.4454 5.54665 14.6054 5.75998 14.5454L7.66665 13.9987L9.57331 14.5454C9.78665 14.6054 9.99998 14.4454 9.99998 14.2254V13.832C9.99998 13.7254 9.95331 13.6254 9.86665 13.5654L8.66665 12.6654V8.9987L13.0933 10.3854C13.5466 10.5254 14 10.1854 14 9.7187Z",
    stroke: "#2F3E88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9206_429029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccFlightTabEnabledIcon);
export default __webpack_public_path__ + "static/media/my-acc-flight-tab-enabled-icon.a1f2b5f6846efc5d1d32f95ac631c5e1.svg";
export { ForwardRef as ReactComponent };